import type {ManagerRecommendationCallRef} from '@api/meerec/types';

export type RecommendationTextPart = {
  text: string;
  /** Есть — фрагмент является подписью звонка и открывает его. */
  communicationSid?: string;
};

/** Фрагменты текста анализа: подписи звонков («19.10 06:44») отдельно от обычного текста. */
export const splitRecommendationCalls = (
  text: string,
  calls: ManagerRecommendationCallRef[] = [],
): RecommendationTextPart[] => {
  const sidByLabel = new Map<string, string>();
  for (const call of calls)
    if (call.label && !sidByLabel.has(call.label))
      sidByLabel.set(call.label, call.communicationSid);
  if (sidByLabel.size === 0) return text ? [{text}] : [];
  const alternatives = [...sidByLabel.keys()]
    .sort((a, b) => b.length - a.length)
    .map((label) => label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .join('|');
  // Подпись не часть другого числа: «19.10 06:44», но не «119.10 06:445».
  const pattern = new RegExp(
    `(?<![\\p{N}])(?:${alternatives})(?![\\p{N}])`,
    'gu',
  );
  const parts: RecommendationTextPart[] = [];
  let offset = 0;
  for (const match of text.matchAll(pattern)) {
    if (match.index > offset)
      parts.push({text: text.slice(offset, match.index)});
    parts.push({text: match[0], communicationSid: sidByLabel.get(match[0])});
    offset = match.index + match[0].length;
  }
  if (offset < text.length) parts.push({text: text.slice(offset)});
  return parts;
};
